// eslint-disable-next-line import/no-cycle
import { schedule as schemaSchedule } from './schemas';
import apiClient from './apiClient';
import ScheduleDataStore from '../../datastores/ScheduleDataStore';

class ScheduleDataStoreGraphQL implements ScheduleDataStore {
  async getSchedule(date: number, periods: string[]) {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaSchedule.getSchedulesV2,
        variables: {
          date,
          periods
        },
        fetchPolicy: 'cache-first'
      });
      return response.data?.scheduleByDate?.dates;
    } catch (error) {
      throw new Error('error schedule');
    }
  }

  async getScheduleByDay(startDate: number, period: string) {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaSchedule.getScheduleByDayV2,
        variables: {
          date: startDate,
          classTypes: [1, 2, 5, 6],
          period
        },
        fetchPolicy: 'network-only'
      });
      return response.data?.schedulesHomeV2;
    } catch (error) {
      throw new Error('error schedule');
    }
  }

  async getScheduleResumeHome(periodId: string) {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaSchedule.getScheduleResume,
        variables: {
          periodId
        },
        fetchPolicy: 'cache-first'
      });
      return response.data.getScheduleResumeHome;
    } catch (error) {
      throw new Error('error schedule resume Home');
    }
  }
}
export default ScheduleDataStoreGraphQL;
